module.exports = __webpack_public_path__ + "static/media/boat-img-44.051c19b6.jpg";